import { connect } from 'react-redux';
import GenericLoader from '../util/GenericLoader';
import {
  fetchEquipForBuildingActionCreator,
  fetchEquipForAllBuildingsActionCreator,
} from '../../redux/actions/equipment';

const mapDispatchToProps = (dispatch, { org, buildingId }) => ({
  fetchFunction: () => {
    if (buildingId) dispatch(fetchEquipForBuildingActionCreator(buildingId)).catch(() => {});
    if (org) dispatch(fetchEquipForAllBuildingsActionCreator(org));
  },
});

export default connect(null, mapDispatchToProps)(GenericLoader);
